var _path, _path2, _path3, _path4, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIconQuoteJuneGradient = function SvgIconQuoteJuneGradient(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 33,
    height: 32,
    fill: "none",
    viewBox: "0 0 33 32"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint0_linear_2543_5632)",
    fillRule: "evenodd",
    d: "M27.179 7.963a.821.821 0 0 0 .065-1.358.812.812 0 0 0-.728-.125c-.621.193-2.892.973-5.023 2.685-2.145 1.723-4.19 4.432-4.19 8.435 0 3.532 2.405 6.4 5.6 6.4h.8a5.6 5.6 0 0 0 .829-11.14c.26-3.278 2.203-4.628 2.647-4.897Z",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint1_linear_2543_5632)",
    fillRule: "evenodd",
    d: "M27.179 7.963a.821.821 0 0 0 .065-1.358.812.812 0 0 0-.728-.125c-.621.193-2.892.973-5.023 2.685-2.145 1.723-4.19 4.432-4.19 8.435 0 3.532 2.405 6.4 5.6 6.4h.8a5.6 5.6 0 0 0 .829-11.14c.26-3.278 2.203-4.628 2.647-4.897Z",
    clipRule: "evenodd"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint2_linear_2543_5632)",
    fillRule: "evenodd",
    d: "M13.579 7.883a.821.821 0 0 0 .065-1.358.812.812 0 0 0-.728-.125c-.621.193-2.892.973-5.023 2.685-2.145 1.723-4.19 4.432-4.19 8.434 0 3.533 2.405 6.4 5.6 6.4h.8a5.6 5.6 0 0 0 .829-11.139c.26-3.278 2.204-4.628 2.647-4.897Z",
    clipRule: "evenodd"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint3_linear_2543_5632)",
    fillRule: "evenodd",
    d: "M13.579 7.883a.821.821 0 0 0 .065-1.358.812.812 0 0 0-.728-.125c-.621.193-2.892.973-5.023 2.685-2.145 1.723-4.19 4.432-4.19 8.434 0 3.533 2.405 6.4 5.6 6.4h.8a5.6 5.6 0 0 0 .829-11.139c.26-3.278 2.204-4.628 2.647-4.897Z",
    clipRule: "evenodd"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2543_5632",
    x1: 3.201,
    x2: 32.502,
    y1: 11.013,
    y2: 17.826,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C02415"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FC951F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2543_5632",
    x1: 3.703,
    x2: 14.029,
    y1: 21.546,
    y2: 21.454,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F07929"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F6B71E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_2543_5632",
    x1: 3.201,
    x2: 32.502,
    y1: 11.013,
    y2: 17.826,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C02415"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FC951F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_2543_5632",
    x1: 3.703,
    x2: 14.029,
    y1: 21.546,
    y2: 21.454,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F07929"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F6B71E"
  })))));
};
export default SvgIconQuoteJuneGradient;